<div class="auth-card">
  <!-- Estado: cargando (comportamiento actual) -->
  <ng-container *ngIf="!accessDenied">
    <p-progressBar [mode]="'indeterminate'" [style]="{ height: '4px', width: '200px' }"></p-progressBar>
    <p>{{ 'USER.WAIT' | translate }}</p>
  </ng-container>

  <!-- Estado: acceso denegado -->
  <ng-container *ngIf="accessDenied">
    <i class="pi pi-lock" style="font-size: 2.5rem; color: var(--red-500)"></i>
    <p style="color: var(--text-color); font-weight: 600; font-size: 1rem;">
      {{ 'USER.ACCESS_DENIED' | translate }}
    </p>
    <p style="color: var(--text-color-secondary); text-align: center; font-size: 0.875rem;">
      {{ 'USER.NOT_REGISTERED_IN_CC' | translate }}
    </p>
    <p-button
      [label]="'USER.BACK_TO_LOGIN' | translate"
      severity="secondary"
      size="small"
      [text]="true"
      (onClick)="goToLogin()"
    />
  </ng-container>
</div>
